export default "__VITE_ASSET__BJZdDFG3__"